import { AxiosResponse } from "axios";
import { ErrorMessages } from "utils/AppMessages/AppMessages";
import IApiResultData from "./model/IApiResultData";

class Remote {
  call<T, D>(
    request: Promise<AxiosResponse<IApiResultData<T>, D>>,
    onSuccess?: (value: IApiResultData<T>) => void,
    onProgress?: (value: boolean) => void,
    onError?: (value: string) => void
  ) {
    if (onProgress != null) {
      onProgress(true);
    }
    request
      .then((response) => {
        if (onProgress != null) {
          onProgress(false);
        }

        if (response.data) {
          console.log(response.data);
        }
        if (response.status === 200 && response.data.isSuccess) {
          if (onSuccess != null) {
            onSuccess(response.data);
          }
        } else if (response.status === 200 && !response.data.isSuccess) {
          if (onError != null) {
            onError(response.data.message);
          }
        } else {
          if (onError != null) {
            onError(ErrorMessages.ErrorConnection);
          }
        }
      })
      .catch(function (error) {
        let message = ErrorMessages.ErrorConnection;
        if (onProgress != null) {
          onProgress(false);
        }
        if (error.response) {
          if (error.response.data) {
            message = error.response.data.message;
          }
          if (error.response.status === 404) {
            message = ErrorMessages.NotFound404;
          }
        } else if (error.request) {
        } else {
        }
        if (onError != null) {
          onError(message);
        }
      });
  }
}

export default new Remote();
